var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCircleBuildingIcon = function SvgCircleBuildingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 32,
    fill: "white",
    stroke: "#C4C4C4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8002 19.2V53",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1998 19.2H47.7998",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1998 53V19.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7998 53H19.1998",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7998 19.2H19.1998L21.7998 14H45.1998L47.7998 19.2Z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 53H53",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4001 49.1C37.4001 48.0657 36.9891 47.0737 36.2578 46.3423C35.5264 45.611 34.5344 45.2 33.5001 45.2C32.4658 45.2 31.4738 45.611 30.7424 46.3423C30.011 47.0737 29.6001 48.0657 29.6001 49.1V53H37.4001V49.1Z",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 23.75C25.8722 23.75 26.0376 23.8185 26.1594 23.9404C26.2813 24.0623 26.3498 24.2276 26.3498 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0499 24.4C25.0499 24.2276 25.1184 24.0623 25.2403 23.9404C25.3622 23.8185 25.5275 23.75 25.6999 23.75",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6999 25.05C25.5275 25.05 25.3622 24.9815 25.2403 24.8596C25.1184 24.7377 25.0499 24.5724 25.0499 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3498 24.4C26.3498 24.5724 26.2813 24.7377 26.1594 24.8596C26.0376 24.9815 25.8722 25.05 25.6998 25.05",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 31.55C25.8722 31.55 26.0376 31.6185 26.1594 31.7403C26.2813 31.8623 26.3498 32.0275 26.3498 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0499 32.2C25.0499 32.0275 25.1184 31.8623 25.2403 31.7403C25.3622 31.6185 25.5275 31.55 25.6999 31.55",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6999 32.85C25.5275 32.85 25.3622 32.7815 25.2403 32.6597C25.1184 32.5377 25.0499 32.3725 25.0499 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3498 32.2C26.3498 32.3725 26.2813 32.5377 26.1594 32.6597C26.0376 32.7815 25.8722 32.85 25.6998 32.85",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 39.35C25.8722 39.35 26.0376 39.4184 26.1594 39.5403C26.2813 39.6623 26.3498 39.8275 26.3498 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0499 40C25.0499 39.8275 25.1184 39.6623 25.2403 39.5403C25.3622 39.4184 25.5275 39.35 25.6999 39.35",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6999 40.65C25.5275 40.65 25.3622 40.5815 25.2403 40.4597C25.1184 40.3377 25.0499 40.1725 25.0499 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3498 40C26.3498 40.1725 26.2813 40.3377 26.1594 40.4597C26.0376 40.5815 25.8722 40.65 25.6998 40.65",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 23.75C33.6725 23.75 33.8377 23.8185 33.9597 23.9404C34.0815 24.0623 34.15 24.2276 34.15 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.85 24.4C32.85 24.2276 32.9184 24.0623 33.0403 23.9404C33.1623 23.8185 33.3275 23.75 33.5 23.75",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 25.05C33.3275 25.05 33.1623 24.9815 33.0403 24.8596C32.9184 24.7377 32.85 24.5724 32.85 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.15 24.4C34.15 24.5724 34.0815 24.7377 33.9597 24.8596C33.8377 24.9815 33.6725 25.05 33.5 25.05",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 31.55C33.6725 31.55 33.8377 31.6185 33.9597 31.7403C34.0815 31.8623 34.15 32.0275 34.15 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.85 32.2C32.85 32.0275 32.9184 31.8623 33.0403 31.7403C33.1623 31.6185 33.3275 31.55 33.5 31.55",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 32.85C33.3275 32.85 33.1623 32.7815 33.0403 32.6597C32.9184 32.5377 32.85 32.3725 32.85 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.15 32.2C34.15 32.3725 34.0815 32.5377 33.9597 32.6597C33.8377 32.7815 33.6725 32.85 33.5 32.85",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 39.35C33.6725 39.35 33.8377 39.4184 33.9597 39.5403C34.0815 39.6623 34.15 39.8275 34.15 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.85 40C32.85 39.8275 32.9184 39.6623 33.0403 39.5403C33.1623 39.4184 33.3275 39.35 33.5 39.35",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 40.65C33.3275 40.65 33.1623 40.5815 33.0403 40.4597C32.9184 40.3377 32.85 40.1725 32.85 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.15 40C34.15 40.1725 34.0815 40.3377 33.9597 40.4597C33.8377 40.5815 33.6725 40.65 33.5 40.65",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3002 23.75C41.4726 23.75 41.6378 23.8185 41.7599 23.9404C41.8817 24.0623 41.9502 24.2276 41.9502 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.65 24.4C40.65 24.2276 40.7185 24.0623 40.8403 23.9404C40.9624 23.8185 41.1276 23.75 41.3 23.75",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 25.05C41.1276 25.05 40.9624 24.9815 40.8403 24.8596C40.7185 24.7377 40.65 24.5724 40.65 24.4",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9502 24.4C41.9502 24.5724 41.8817 24.7377 41.7599 24.8596C41.6378 24.9815 41.4726 25.05 41.3002 25.05",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3002 31.55C41.4726 31.55 41.6378 31.6185 41.7599 31.7403C41.8817 31.8623 41.9502 32.0275 41.9502 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.65 32.2C40.65 32.0275 40.7185 31.8623 40.8403 31.7403C40.9624 31.6185 41.1276 31.55 41.3 31.55",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 32.85C41.1276 32.85 40.9624 32.7815 40.8403 32.6597C40.7185 32.5377 40.65 32.3725 40.65 32.2",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9502 32.2C41.9502 32.3725 41.8817 32.5377 41.7599 32.6597C41.6378 32.7815 41.4726 32.85 41.3002 32.85",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3002 39.35C41.4726 39.35 41.6378 39.4184 41.7599 39.5403C41.8817 39.6623 41.9502 39.8275 41.9502 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.65 40C40.65 39.8275 40.7185 39.6623 40.8403 39.5403C40.9624 39.4184 41.1276 39.35 41.3 39.35",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 40.65C41.1276 40.65 40.9624 40.5815 40.8403 40.4597C40.7185 40.3377 40.65 40.1725 40.65 40",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9502 40C41.9502 40.1725 41.8817 40.3377 41.7599 40.4597C41.6378 40.5815 41.4726 40.65 41.3002 40.65",
    stroke: "#C4C4C4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleBuildingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleBuildingIcon.5b65d2ed.svg";
export { ForwardRef as ReactComponent };